import { TypeKeys, ActionTypes } from '../actions/index';
import { careAreas } from '../global/exercise-consts';

const getInitialState = (): ExercisesState => {
  return {
    filterCount: 0,
    filters: noExerciseFilters(),
    searchTerm: null,
  };
};

const exercises = (
  state = getInitialState(),
  action: ActionTypes
): ExercisesState => {
  switch (action.type) {
    case TypeKeys.SET_EXERCISE_FILTERS: {
      const filterCount = countFilters(action.filters);
      return {
        ...state,
        filters: { ...state.filters, ...action.filters },
        filterCount,
      };
    }
    case TypeKeys.SEARCH_EXERCISES: {
      return {
        ...state,
        searchTerm: action.searchTerm,
      };
    }
    case TypeKeys.CLEAR_EXERCISE_FILTERS: {
      return {
        ...state,
        filterCount: 0,
        filters: noExerciseFilters(),
        searchTerm: null,
      };
    }
  }
  return state;
};

export default exercises;

/////

function noExerciseFilters() {
  return {
    difficulty: {
      easy: false,
      medium: false,
      hard: false,
    },
    category: {
      upper: false,
      lower: false,
      core: false,
      cardio: false,
      yoga: false,
      pilates: false,
      stretch: false,
      pt: false,
      barre: false,
    },
    stance: { floor: false, standing: false, seated: false },
    impact: { low: false, normal: false, high: false },
    focusAreas: {
      abs: false,
      biceps: false,
      calves: false,
      chest: false,
      glutes: false,
      hamstrings: false,
      hipFlexor: false,
      lowerBack: false,
      quadriceps: false,
      shoulders: false,
      upperBack: false,
      triceps: false,
    },
    careAreas,
    noise: { quiet: false },
    equipment: {
      kettlebell: false,
      bodyweight: false,
      dumbbell: false,
      band: false,
      loop: false,
      foamroller: false,
      barre: false,
      chair: false,
      pilatesball: false,
    },
    classification: {
      kids: false,
      standard: false,
    },
  };
}

function countFilters(filters: ExerciseFilters) {
  let activeFilterCount = 0;
  Object.keys(filters).map((filter) => {
    Object.keys(filters[filter]).map((option) => {
      if (filters[filter][option]) {
        activeFilterCount++;
      }
    });
  });
  return activeFilterCount;
}
